module.exports = __webpack_public_path__ + "img/wares_image.29ded1e7.png";